import { render } from "./QuizTestComp.vue?vue&type=template&id=a652cf30&scoped=true"
import script from "./QuizTestComp.vue?vue&type=script&lang=js"
export * from "./QuizTestComp.vue?vue&type=script&lang=js"

import "./QuizTestComp.vue?vue&type=style&index=0&id=a652cf30&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a652cf30"]])

export default __exports__